// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { updateQuote as updateQuoteApi } from "@bg/App/Services/QuoteService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
    SendDataToApi,
} from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/SubmitQuote";

export const XngPopulateApiParameter: any = (props: any) => {
    const state = props.getState() as any;
    const followUpDate = state.commonActions["followUpDate"];
    const isQuoteFreight = state.commonActions["isQuoteFreight"]?.isFrieght;
    const freightCost = state.commonActions["freightValue"];

    const month = followUpDate?.getMonth() + 1;
    const day = followUpDate?.getDate();
    const year = followUpDate?.getFullYear();
    props.apiParameter = {
        quoteId: props.parameter.quote.id,
        status: "QuoteProposed",
        expirationDate: props.getState().pages.rfqQuoteDetails.expirationDate,
        followUpDate: `${month}/${day}/${year}`,
        isQuoteFreight,
        freightCost,
    } as any;
};

export const XngSendDataToApi: any = async (props: any) => {
    const result = await updateQuoteApi(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.dispatch({
            type: "commonActionSetter/SetAction",
            payload: { name: "isLoading", value: false },
        });
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, SendDataToApi, XngSendDataToApi);
